import { Header } from '../components/Header';

import { FullPost } from 'model';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { Virtuoso } from 'react-virtuoso';
import { useSearchPostByAuthorQuery } from '../api/PostApi';
import { IconButton } from '../components/IconButton';
import { NoResults } from '../components/NoResults';
import { PostListItem } from '../components/PostListItem';
import { IconArrowBack, IconHelp } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { QuirkLoader } from '../components/QuirkLoader';
const FeedView: React.FC<{ item: FullPost }> = ({ item }) => {
	if (item.type === 'post') {
		return <PostListItem key={item._id} post={item} />;
	}
	return <div>Not implemented</div>;
};

export const UserPosts: React.FC<{}> = () => {
	const { id } = useParams<{ id: string }>();
	const { data: feed, isLoading } = useSearchPostByAuthorQuery(id);
	const history = useHistory();
	return (
		<QuirkIonPage name="User Posts" data={{ user: id }}>
			<Header title="logo" left={<IconButton icon={<IconArrowBack />} onClick={() => history.go(-1)} />} />
			<QuirkIonContent scroll={false}>
				<QuirkLoader
					isLoading={isLoading}
					loadingMessage="Loading posts..."
					data={feed}
					noResults={
						<NoResults
							heading="No posts found."
							subheading="Refine or clear your search filters."
							icon={<IconHelp />}
						/>
					}
				>
					<Virtuoso
						totalCount={feed?.length}
						data={feed}
						itemContent={(index, item) => (
							<div>
								<FeedView item={item} />
							</div>
						)}
					/>
				</QuirkLoader>
			</QuirkIonContent>
		</QuirkIonPage>
	);
};
